const productColors = {
  Amber: "#B56F32",
  Black: "#1D1B1A",
  Blue: "#5D7892",
  Brick: "#A6533F",
  Burgundy: "#7B263D",
  Caramel: "#B77A4A",
  Chocolate: "#4A2E25",
  Cobalt: "#2451A4",
  "Cobalt blue": "#2451A4",
  Cocoa: "#5A3A2D",
  Cream: "#E8DDC6",
  "Glossy black": "#141414",
  Hazel: "#9A6B43",
  Ivory: "#EEE8DA",
  Merlot: "#72263C",
  Mocha: "#705345",
  Oat: "#D4C3A5",
  Olive: "#727956",
  Plum: "#68405C",
  Sage: "#98A28B",
  Sand: "#C9AE86",
  Tan: "#B87946",
  White: "#F5F2EA",
};

export const getProductColor = (name) => productColors[name] || "#8C776A";

export default productColors;
